var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-Document-Management-Gear-Envelope"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47 6v45a2.006 2.006 0 0 1 -2 2h-36a2.032 2.032 0 0 1 -.55-.08 2.085 2.085 0 0 1 -.92-.56 2.339 2.339 0 0 1 -.29-.41 2.028 2.028 0 0 1 -.24-.95v-45l3.86 6.94a4.033 4.033 0 0 0 3.49 2.06h25.3a3.988 3.988 0 0 0 3.49-2.06z",
    fill: "#a97c50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 48v4l-3.32.47c-.05.18-.1.36-.15.53h-18.53a2.032 2.032 0 0 1 -.55-.08c-.05-.15-.09-.3-.13-.45l-.79-.11a2.339 2.339 0 0 1 -.29-.41 2.028 2.028 0 0 1 -.24-.95v-3.28l1.32-.19a9.492 9.492 0 0 1 .68-1.85 8.141 8.141 0 0 1 .41-.77l-.41-.55-1.61-2.14 2.83-2.83 2.69 2.02a9.8 9.8 0 0 1 2.62-1.09l.47-3.32h4l.47 3.32a9.8 9.8 0 0 1 2.62 1.09l2.69-2.02 2.83 2.83-2.02 2.69a9.8 9.8 0 0 1 1.09 2.62z",
    fill: "#8b5e3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.64 53a.405.405 0 0 1 -.05.09l2.02 2.69-2.83 2.83-2.69-2.02a9.8 9.8 0 0 1 -2.62 1.09l-.47 3.32h-4l-.47-3.32a9.8 9.8 0 0 1 -2.62-1.09l-2.69 2.02-2.83-2.83 2.02-2.69a9.253 9.253 0 0 1 -.51-.99 9.011 9.011 0 0 1 -.58-1.63l-3.32-.47v-4l3.32-.47a9.492 9.492 0 0 1 .68-1.85 8.141 8.141 0 0 1 .41-.77l-.41-.55-1.61-2.14 2.83-2.83 2.69 2.02a9.8 9.8 0 0 1 2.62-1.09l.47-3.32h4l.47 3.32a9.8 9.8 0 0 1 2.62 1.09l2.69-2.02 2.83 2.83-2.02 2.69a9.8 9.8 0 0 1 1.09 2.62l3.32.47v4l-3.32.47a9.427 9.427 0 0 1 -1.04 2.53z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 6v5.6l-1.86 3.34a3.988 3.988 0 0 1 -3.49 2.06h-25.3a3.988 3.988 0 0 1 -3.49-2.06l-.17-.31a3.911 3.911 0 0 0 1.66.37h25.3a3.988 3.988 0 0 0 3.49-2.06z",
    fill: "#8b5e3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 5v1l-3.86 6.94a3.988 3.988 0 0 1 -3.49 2.06h-25.3a3.988 3.988 0 0 1 -3.49-2.06l-3.86-6.94v-1a2.006 2.006 0 0 1 2-2h36a2.006 2.006 0 0 1 2 2z",
    fill: "#a1754d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 27h-6a2.006 2.006 0 0 1 -2-2v-6z",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 27v28a2.006 2.006 0 0 1 -2 2h-24a2.006 2.006 0 0 1 -2-2v-34a2.006 2.006 0 0 1 2-2h18v6a2.006 2.006 0 0 0 2 2z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 48,
    fill: "#ffd422",
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 35v20a2.006 2.006 0 0 1 -2 2h-20z",
    fill: "#d8d7da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 10h2v10h-2z",
    fill: "#754c29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 24h4v2h-4z",
    fill: "#c6c5ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 24h2v2h-2z",
    fill: "#c6c5ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 28h8v2h-8z",
    fill: "#c6c5ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 36h2v5h-2z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 34h2v7h-2z",
    fill: "#ffd422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 32h2v9h-2z",
    fill: "#00ccb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 46h2v2h-2z",
    fill: "#c6c5ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 46h14v2h-14z",
    fill: "#c6c5ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 50h18v2h-18z",
    fill: "#c6c5ca"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ee8700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 38h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.636 40.636h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 -26.615 19.002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.636 53.364h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 -35.619 22.736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 56h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.364 53.364h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 -31.887 31.727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 47h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.364 40.636h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 -22.891 28.009)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 9,
    fill: "#8b5e3c",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 21,
    fill: "#8b5e3c",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 40h14v2h-14z",
    fill: "#898890"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/ProjectIcon.bb9260edff76a5362aac90b045bf517c.svg";
export { ForwardRef as ReactComponent };